"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLineageUrnAndVersion = exports.decodeUrn = void 0;
const decodeUrn = urn => {
  urn = urn.replace(/-/g, "+"); // Convert '-' (dash) to '+'
  urn = urn.replace(/_/g, "/"); // Convert '_' (underscore) to '/'
  while (urn.length % 4) {
    urn += "=";
  } // Add padding '='
  return atob(urn);
};
exports.decodeUrn = decodeUrn;
const getLineageUrnAndVersion = versionUrn => {
  const regex = /urn:adsk\.(\w*):fs.file:vf.([^?]*)\?version=(\d*)/;
  const matches = regex.exec(versionUrn);
  if (!matches) {
    return;
  }
  const wipDmEnv = matches[1];
  const lineageId = matches[2];
  const version = parseInt(matches[3], 10);
  return {
    lineageUrn: "urn:adsk.".concat(wipDmEnv, ":dm.lineage:").concat(lineageId),
    versionNumber: version
  };
};
exports.getLineageUrnAndVersion = getLineageUrnAndVersion;
//# sourceMappingURL=urnUtils.js.map